<template>
  <header
    :class="[
      'header',
      { 'banner-visible': displayBanner && bannerVisible}
    ]"
  >
  <!-- :style="{ height: height ? `${height}px` : 'auto' }" -->

    <div class="header-wrapper">
      <!-- { 'is-sticky': isSticky }, -->
      <!-- { 'is-invisible': isSticky && isInvisible }, -->

      <nav class="header-nav">
        <ul class="header-nav-list">
          <li class="header-nav-item">
            <router-link class="header-nav-link" to="/">
              <sprite
                :type="'agenda'"
                :width="24"
                :height="21"
              />

              <span class="text">Agenda</span>
            </router-link>
          </li>

          <li class="header-nav-item">
            <router-link class="header-nav-link" to="/multimedias">
              <sprite
                :type="'play'"
                :width="21"
                :height="21"
              />
              <span class="text">3° Scène</span>
            </router-link>
          </li>

          <li class="header-nav-item">
            <router-link class="header-nav-link" to="/orders">
              <sprite
                :type="'ticket'"
                :width="21"
                :height="21"
              />
              <span class="text">Mes billets</span>
            </router-link>
          </li>

          <li class="header-nav-item">
            <router-link class="header-nav-link" to="/profile">
              <sprite
                :type="'profile'"
                :width="20"
                :height="20"
              />

              <span class="text">Mon profil</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Sprite
  },
  data() {
    return {
      // isSticky: false,
      // isVisible: false,
      // isInvisible: false,
      // height: 0,
      bannerVisible: false,
      // bannerHeight: 0,
      scroll: this.onScroll.bind(this),
      scrollY: null
    };
  },
  mounted() {
    this.onScroll();
    window.addEventListener('scroll', this.scroll);
  },
  computed: {
    displayBanner() {
      return this.$store.state.banner.display
      && !this.$store.state.banner.bannerClosed;
    },
    bannerHeight() {
      return this.$store.state.banner.bannerHeight;
    }
  },
  methods: {
    onScroll() {
      const scrollY = window.scrollY || window.pageYOffset;

      if (scrollY === this.scrollY) {
        return;
      }

      if (scrollY > this.bannerHeight) {
        this.bannerVisible = false;
      } else {
        this.bannerVisible = true;
      }

      this.scrollY = scrollY;
      return;

      /* eslint-disable */
      // Scoll down
      if (scrollY >= this.scrollY) {
        if (scrollY > this.height) {
          this.isSticky = true;
        }

        if (!this.isInvisible) {
          this.isInvisible = true;
        }
      } else {
        // Scroll up
        if (scrollY <= 5) {
          this.isSticky = false;
        }

        if (this.isInvisible) {
          this.isInvisible = false;
        }

        // if (!this.isVisible) {
        //   this.isVisible = true;
        // }
      }

      this.scrollY = scrollY;
    }
  }
};
</script>

<style lang="scss" scoped>
  .header {
    position: absolute;
    z-index: 1000;

    &-nav {
      @include position(fixed, null null 0 0);
      @include padding(null 20px);
      @include size(100%, auto);
      border-top: 1px solid rgba($white, .1);
      background-color: $black-light;
      padding-bottom: 5px;

      &-list {
        display: flex;
      }

      &-item {
        width: 33.33%;
      }

      &-link {
        @include padding(14px null 9px);
        @include font('secondary', 'regular');
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        color: rgba($white, .5);
        font-size: rem(16px);
        line-height: (19 / 16);

        &.router-link-exact-active {
          color: $primary;

          .svg {
            fill: $primary;
          }
        }

        .svg {
          fill: rgba($white, .5);
        }

        .text {
          @include margin(4px null null);
          text-align: center;
        }
      }
    }
  }
</style>
